import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function normTri(v) {
  const n = Number(v);
  return n === 0 || n === 1 || n === 2 ? n : 0;
}

function triLabel(v) {
  const n = Number(v);
  if (n === 0) return "PENDENTE";
  if (n === 1) return "CORRETA";
  if (n === 2) return "INCORRETA";
  return "PENDENTE";
}

function formatDateTime(v) {
  if (!v) return "";
  const s = String(v);
  if (s.includes("T")) return s.replace("T", " ").slice(0, 19);
  return s;
}

function quemQuando(nome, dt) {
  const n = (nome ?? "").toString().trim();
  const d = formatDateTime(dt);
  if (!n && !d) return "—";
  if (n && d) return `${n} em ${d}`;
  return n || d;
}

export default function DialogFichaTransporteDetalhe({
  open,
  onClose,
  row,
  onAbrirTransportesRef,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        Detalhe da Ficha de Transporte Refª
        <MDTypography
          component="span"
          sx={{
            color: "info.main",
            cursor: "pointer",
            // textDecoration: "underline",
            ml: 1,
          }}
          onClick={() => row?.reftransporte && onAbrirTransportesRef?.(row.reftransporte)}
        >
          {row?.reftransporte}
        </MDTypography>
      </DialogTitle>

      <DialogContent dividers>
        {/* TOPO: Geral + Auxílio */}
        <MDBox display="flex" gap={2} flexWrap="wrap">
          {/* GERAL */}
          <MDBox
            sx={{
              flex: 1,
              minWidth: 300,
              p: 2,
              borderRadius: 2,
              bgcolor: "#f8f9fa",
              border: "1px solid #e0e0e0",
            }}
          >
            <MDTypography sx={{ fontSize: 14, fontWeight: 700, mb: 1 }}>Geral</MDTypography>

            <MDTypography sx={{ fontSize: 13, mb: 0.5 }}>
              <b>Data:</b> {row?.dataficha ? String(row.dataficha).slice(0, 10) : ""}
            </MDTypography>

            <MDTypography sx={{ fontSize: 13, mb: 0.5 }}>
              <b>Distribuidor 1:</b> {row?.motorista || "—"}
            </MDTypography>

            <MDTypography sx={{ fontSize: 13, mb: 0.5 }}>
              <b>Distribuidor 2:</b> {row?.ajudante || "—"}
            </MDTypography>

            <MDTypography sx={{ fontSize: 13, mb: 1 }}>
              <b>Matrícula:</b> {row?.matricula || "—"}
            </MDTypography>

            <MDTypography sx={{ fontSize: 13, mb: 0.5 }}>
              <b>Mapa de Carga:</b> {triLabel(row?.conf_mapa_carga)}
            </MDTypography>

            {normTri(row?.conf_mapa_carga) === 2 && (
              <MDTypography sx={{ fontSize: 12, mb: 0.5, opacity: 0.85, whiteSpace: "pre-wrap" }}>
                {row?.conf_mapa_carga_desc || "(sem descritivo)"}
              </MDTypography>
            )}

            <MDTypography sx={{ fontSize: 12, mb: 1, opacity: 0.75 }}>
              <b>Atualizado por:</b>{" "}
              {quemQuando(row?.conf_mapa_carga_nome, row?.conf_mapa_carga_datahora)}
            </MDTypography>

            <MDTypography sx={{ fontSize: 13, fontWeight: 700, mt: 1 }}>Observações</MDTypography>
            <MDBox
              sx={{
                mt: 0.5,
                p: 1.5,
                borderRadius: 1.5,
                bgcolor: "#ffffff",
                border: "1px dashed #ccc",
                fontSize: 13,
                whiteSpace: "pre-wrap",
              }}
            >
              {row?.observacoes || "(sem observações)"}
            </MDBox>

            <MDTypography sx={{ fontSize: 12, mt: 1, opacity: 0.8 }}>
              <b>Encerramento:</b> {quemQuando(row?.encerramento_nome, row?.dataencerramento)}
            </MDTypography>

            <MDTypography sx={{ fontSize: 12, opacity: 0.8 }}>
              <b>Reabertura:</b> {quemQuando(row?.reabertura_nome, row?.datareabertura)}
            </MDTypography>
          </MDBox>

          {/* AUXÍLIO ARMAZÉM */}
          <MDBox
            sx={{
              flex: 1,
              minWidth: 260,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* ARMAZÉM 1 */}
            <MDBox
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "#f8f9fa",
                border: "1px solid #e0e0e0",
              }}
            >
              <MDTypography sx={{ fontSize: 14, fontWeight: 700, mb: 1 }}>
                Auxílio Armazém 1
              </MDTypography>

              <MDTypography sx={{ fontSize: 13 }}>
                <b>Distribuidor 1:</b> {row?.auxilio_mot_arm1 === 1 ? "Sim" : "Não"}
              </MDTypography>
              <MDTypography sx={{ fontSize: 12, mt: 0.5, opacity: 0.75 }}>
                <b>Atualizado por:</b>{" "}
                {quemQuando(row?.auxilio_mot_arm1_nome, row?.auxilio_mot_arm1_datahora)}
              </MDTypography>

              <MDTypography sx={{ fontSize: 13, mt: 1.5 }}>
                <b>Distribuidor 2:</b> {row?.auxilio_ajud_arm1 === 1 ? "Sim" : "Não"}
              </MDTypography>
              <MDTypography sx={{ fontSize: 12, mt: 0.5, opacity: 0.75 }}>
                <b>Atualizado por:</b>{" "}
                {quemQuando(row?.auxilio_ajud_arm1_nome, row?.auxilio_ajud_arm1_datahora)}
              </MDTypography>
            </MDBox>

            {/* ARMAZÉM 2 */}
            <MDBox
              sx={{
                p: 2,
                borderRadius: 2,
                bgcolor: "#f8f9fa",
                border: "1px solid #e0e0e0",
              }}
            >
              <MDTypography sx={{ fontSize: 14, fontWeight: 700, mb: 1 }}>
                Auxílio Armazém 2
              </MDTypography>

              <MDTypography sx={{ fontSize: 13 }}>
                <b>Distribuidor 1:</b> {row?.auxilio_mot_arm2 === 1 ? "Sim" : "Não"}
              </MDTypography>
              <MDTypography sx={{ fontSize: 12, mt: 0.5, opacity: 0.75 }}>
                <b>Atualizado por:</b>{" "}
                {quemQuando(row?.auxilio_mot_arm2_nome, row?.auxilio_mot_arm2_datahora)}
              </MDTypography>

              <MDTypography sx={{ fontSize: 13, mt: 1.5 }}>
                <b>Distribuidor 2:</b> {row?.auxilio_ajud_arm2 === 1 ? "Sim" : "Não"}
              </MDTypography>
              <MDTypography sx={{ fontSize: 12, mt: 0.5, opacity: 0.75 }}>
                <b>Atualizado por:</b>{" "}
                {quemQuando(row?.auxilio_ajud_arm2_nome, row?.auxilio_ajud_arm2_datahora)}
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>

        {/* OCORRÊNCIAS (100% largura) */}
        <MDBox
          sx={{
            mt: 3,
            p: 2,
            borderRadius: 2,
            bgcolor: "#f8f9fa",
            border: "1px solid #e0e0e0",
          }}
        >
          <MDTypography sx={{ fontSize: 14, fontWeight: 700, mb: 1 }}>Ocorrências</MDTypography>

          <MDBox display="flex" gap={2} flexWrap="wrap">
            {/* Dif. Mercadoria */}
            <MDBox
              sx={{
                flex: 1,
                minWidth: 200,
                p: 1.5,
                bgcolor: "#ffffff",
                borderRadius: 1.5,
                border: "1px solid #e0e0e0",
              }}
            >
              <MDTypography sx={{ fontSize: 13, fontWeight: 600 }}>Dif. Mercadoria</MDTypography>
              <MDTypography sx={{ fontSize: 13 }}>{triLabel(row?.dif_mercadoria)}</MDTypography>
              <MDTypography sx={{ fontSize: 12, mt: 0.5, whiteSpace: "pre-wrap", opacity: 0.85 }}>
                {normTri(row?.dif_mercadoria) === 2
                  ? row?.dif_mercadoria_desc || "(sem descritivo)"
                  : "—"}
              </MDTypography>
              <MDTypography sx={{ fontSize: 12, mt: 0.5, opacity: 0.75 }}>
                <b>Atualizado por:</b>{" "}
                {quemQuando(row?.dif_mercadoria_nome, row?.dif_mercadoria_datahora)}
              </MDTypography>
            </MDBox>

            {/* Quebras / Danificado */}
            <MDBox
              sx={{
                flex: 1,
                minWidth: 200,
                p: 1.5,
                bgcolor: "#ffffff",
                borderRadius: 1.5,
                border: "1px solid #e0e0e0",
              }}
            >
              <MDTypography sx={{ fontSize: 13, fontWeight: 600 }}>
                Quebras / Danificado
              </MDTypography>
              <MDTypography sx={{ fontSize: 13 }}>{triLabel(row?.quebras_danificado)}</MDTypography>

              <MDTypography sx={{ fontSize: 12, mt: 0.5, whiteSpace: "pre-wrap", opacity: 0.85 }}>
                {normTri(row?.quebras_danificado) === 2
                  ? row?.quebras_danificado_desc || "(sem descritivo)"
                  : "—"}
              </MDTypography>

              <MDTypography sx={{ fontSize: 12, mt: 0.5, opacity: 0.75 }}>
                <b>Atualizado por:</b>{" "}
                {quemQuando(row?.quebras_danificado_nome, row?.quebras_danificado_datahora)}
              </MDTypography>
            </MDBox>

            {/* Dif. Vasilhame */}
            <MDBox
              sx={{
                flex: 1,
                minWidth: 200,
                p: 1.5,
                bgcolor: "#ffffff",
                borderRadius: 1.5,
                border: "1px solid #e0e0e0",
              }}
            >
              <MDTypography sx={{ fontSize: 13, fontWeight: 600 }}>Dif. Vasilhame</MDTypography>
              <MDTypography sx={{ fontSize: 13 }}>{triLabel(row?.dif_vasilhame)}</MDTypography>

              <MDTypography sx={{ fontSize: 12, mt: 0.5, whiteSpace: "pre-wrap", opacity: 0.85 }}>
                {normTri(row?.dif_vasilhame) === 2
                  ? row?.dif_vasilhame_desc || "(sem descritivo)"
                  : "—"}
              </MDTypography>

              <MDTypography sx={{ fontSize: 12, mt: 0.5, opacity: 0.75 }}>
                <b>Atualizado por:</b>{" "}
                {quemQuando(row?.dif_vasilhame_nome, row?.dif_vasilhame_datahora)}
              </MDTypography>
            </MDBox>
          </MDBox>
        </MDBox>
      </DialogContent>

      <DialogActions>
        <MDButton color="light" onClick={onClose}>
          Fechar
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
